<h2>{{ 'Ambient environment lights' | translate }}</h2>

<k-slider
  [label]="('Light intensity from above' | translate) + ': ' + getLightIntensity('ambientlightUp')"
  [min]="0"
  [max]="50"
  [startingValue]="getLightIntensity('ambientlightUp')"
  (valueChanged)="setLightIntensity($event, 'ambientlightUp')"
  [showInfo]="true"
  [showTooltip]="true"
></k-slider>

<k-slider
  [label]="('Light intensity from below' | translate) + ': ' + getLightIntensity('ambientlightDown')"
  [min]="0"
  [max]="50"
  [startingValue]="getLightIntensity('ambientlightDown')"
  (valueChanged)="setLightIntensity($event, 'ambientlightDown')"
  [showInfo]="true"
  [showTooltip]="true"
></k-slider>

<h2>{{ 'Pointlight' | translate }}</h2>

<k-slider
  [label]="('Pointlight intensity' | translate) + ': ' + getLightIntensity('pointLight')"
  [min]="0"
  [max]="50"
  [startingValue]="getLightIntensity('pointLight')"
  (valueChanged)="setLightIntensity($event, 'pointLight')"
  [showInfo]="true"
  [showTooltip]="true"
></k-slider>

<div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px">
  <k-input
    [label]="'X-axis' | translate"
    [min]="0"
    [max]="5"
    type="number"
    [startingValue]="pointLightX"
    (valueChanged)="setPointlightPosition('x', $event.valueAsNumber)"
  />

  <k-input
    [label]="'Y-axis' | translate"
    [min]="0"
    [max]="5"
    type="number"
    [startingValue]="pointLightY"
    (valueChanged)="setPointlightPosition('y', $event.valueAsNumber)"
  />

  <k-input
    [label]="'Z-axis' | translate"
    [min]="0"
    [max]="5"
    type="number"
    [startingValue]="pointLightZ"
    (valueChanged)="setPointlightPosition('z', $event.valueAsNumber)"
  />
</div>

<k-button (click)="resetLights()" type="outlined-primary">
  {{ 'Reset lights' | translate }}
</k-button>